import { render } from "./ActivitatInnovacioView.vue?vue&type=template&id=dcf045aa&scoped=true"
import script from "./ActivitatInnovacioView.vue?vue&type=script&lang=js"
export * from "./ActivitatInnovacioView.vue?vue&type=script&lang=js"

import "./ActivitatInnovacioView.vue?vue&type=style&index=0&id=dcf045aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf045aa"]])

export default __exports__